<template>
  <div v-if="!hide" :class="ParentDivClasses">
    <div class="d-inline" v-if="useSvg">
      <font-awesome-icon
        icon="check-circle"
        class="color-green"
        v-if="rightIf"
      />
      <font-awesome-icon
        icon="times-circle"
        class="text-danger"
        v-if="wrongIf"
      />
    </div>
    <div class="d-inline" v-else>
      <span class="f18 color-green" v-if="rightIf">&#10003;</span>
      <span class="f18 text-danger" v-if="wrongIf">x</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["rightIf", "wrongIf", "useSvg", "ParentDivClasses", "hide"],
};
</script>